<mat-table [dataSource]="organizations" *ngIf="organizations" class="mat-effects">
    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Organizacja</mat-header-cell>
        <mat-cell *matCellDef="let organization"> {{ organization.name }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef >Akcje</mat-header-cell>
        <mat-cell *matCellDef="let organization">
            <button (click)="joinOrganization(organization)" [hidden]="isCurrent(organization)">Przełącz</button>
            <span [hidden]="isCurrent(organization)">|</span>
            <button (click)="changeToIndividual()" [hidden]="!isCurrent(organization)">Wyloguj z organizacji</button>
            <button (click)="removeUserOrganization(organization)" [hidden]="isCurrent(organization)">Wystąp z organizacji</button>
        </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: false"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay;"></mat-row>
</mat-table>

<div class="organization-create">
    <mat-form-field>
        <mat-label>Nowa organizacja</mat-label>
        <input matInput placeholder="Moja organizacja..." [value]="newOrganizationName"
               (input)="organizationNameChange($event)">
    </mat-form-field>
    <button (click)="createOrganization()" [disabled]="!organizationCreateButtonEnabled">Utwórz nową organizację</button>
</div>